module.exports = __webpack_public_path__ + "static/media/Logo.5e625c9f.png";